module.exports = __webpack_public_path__ + "static/img/bcg0.370f0d3e.webp";